module.exports = __webpack_public_path__ + "img/flag-pe.f4daf043.svg";